import React from "react";

import * as Icon from "@/assets/newsvg";

const themeForIcon = {
  lightBlue: "White",
  qiongji: "Dark",
  miyou: "Dark",
  chihui: "White",
  shuangji: "Dark",
  yuanmo: "White",
  shuimo: "White"
};

export type ThemeType = keyof typeof themeForIcon;
export type IconType = keyof typeof Icon;

function ThemeIcon(props: { name: string; theme: ThemeType; active?: boolean }) {
  const { name, theme, active } = props;
  const IconName: IconType = active
    ? (`${name}ActiveIcon` as IconType)
    : (`${name}${themeForIcon[theme]}Icon` as IconType);
  const Cmp = Icon[IconName];
  return <Cmp />;
}

export default ThemeIcon;
